// import {loadPage} from '@/helpers/routing'

/**
 * screen a f7 alert on error.
 *
 * @param {Error} error - an error.
 * @param {Vue} element - the vue component.
 */
export const errorMessageAlert = (error, element, silent = false) => {
  let that = element
  that.$f7.hidePreloader()
  if (error.response) {
    switch (error.response.status) {
      case 400:
        if (error.response.data) {
          if (error.response.data.error && error.response.data.errorDescription) {
            var titleError = error.response.data.error
            var descError = error.response.data.errorDescription
            if (that.$i18n.t('errors._specific.title.' + titleError).localeCompare('errors._specific.title.' + titleError) === '0' && !silent) {
              descError = titleError
              that.$f7.alert(that.$i18n.t('errors._specific.description.' + descError), that.$i18n.t('errors._specific.title.' + titleError))
            } else if (!silent) {
              that.$f7.alert(descError, titleError)
            }
          } else if (error.response.data.statusText && !silent) {
            that.$f7.alert('', error.response.data.statusText)
          } else if (error.response.data.errors) {
            /** @author TLV 26/01/2021
            * @brief Ajout de la gestion de multiples erreurs retournées par la modé
            * @details Besoin d'ajouter les traductions une par une pour que la modé puisse
            *         fonctionner indépendamment de l'ihm
            */
            let errorDescMulti = ''
            var titleError
            var descError
            error.response.data.errors.forEach(err => {
              titleError = err.error
              descError = err.errorDescription
              if (errorDescMulti === '') {
                errorDescMulti = err.errorDescription
              } else {
                errorDescMulti += '<br/>' + err.errorDescription
              }

              if (err.errorDescription === 'Siren key parameter is invalid' && !silent) {
                that.$f7.alert(that.$i18n.t('errors.invalid_siren'), that.$i18n.t('errors.invalid_param'))
              }
            })
              /** @author FJE 03/02/2021
            * @brief Ajout de la vérification que la traduction d'une erreur existe ou retour de l'erreur retourné par la modélisation
            * @details Besoin d'ajouter les traductions une par une et retour de l'erreur retournée par la modé pour que l'erreur puisse
            *         être remontée indépendamment de l'ihm
            */
            //errorDescMulti = errorDescMulti.replace(/[A-Z]/gm, '$1' + ' ' + '$2')
            titleError = titleError.replace(/\s/g, '_')
            descError = descError.replace(/\s/g, '_')
            console.log('descError', descError)
            console.log('titleError', titleError)
            if ((that.$i18n.t('errors.' + descError).localeCompare('errors.' + descError) === '0' && that.$i18n.t('errors.' + titleError).localeCompare('errors.' + titleError) === '0') && !silent) {
              that.$f7.alert(that.$i18n.t('errors.' + descError), that.$i18n.t('errors.' + titleError))
            } else if (!silent) {
              // that.$f7.alert(err.errorDescription, err.error)
              that.$f7.alert(errorDescMulti, that.$i18n.t('errors.error_label'))
            }

          }
        } else if (!silent) {
          that.$f7.alert('', error.response.statusText ? error.response.statusText : that.$i18n.t('errors.error_label'))
        }
        break
      case 401:

        // that.$f7.alert('Please Log in again', 'Session finished')
        that.$bus.$emit('logout', true)
        break
      case 406:
        if (!silent) {
          that.$f7.alert('Please, try to connect again', 'Session Failed')
        }
        break
      case 409:
        if (!silent) {
          that.$f7.alert('You will receive a new code', 'Code Expired')
        }
        break
      case 424:
        if (!silent) {
          that.$f7.alert('Please follow the activation link provided via email', 'Activation failed')
        }
        break
      case 428:
        if (!silent) {
          that.$f7.alert(that.$i18n.t('loginPage.no_profile'), that.$i18n.t('errors.error_label'))
        }
        break
      default:
        if (error.response.data && error.response.data && !silent) {
          that.$f7.alert(error.response.data.errorDescription ? error.response.data.errorDescription : that.$i18n.t('errors.error_happened'), error.response.data.error ? error.response.data.error : that.$i18n.t('errors.error_label'))
        } else if (!silent) {
          that.$f7.alert(that.$i18n.t('errors.error_happened'), that.$i18n.t('errors.error_label'))
        }
    }
  } else if (!silent) {
    that.$f7.alert('We will get it fixed as soon as we can.', 'Something went wrong with the Network')
    console.log(error, element)
  }
}
